<template>
  <div class='Box'>
    <el-card class="box-card">

      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小程序名称">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="小程序名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台类型">
              <el-select v-model="queryParams.platform_type" @change="search" @clear="search" placeholder="请选择平台类型"
                         clearable class="w100">
                <!-- <el-option label="抖音" :value=1></el-option> -->
                <el-option label="微信" :value=2></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button size="medium" type="primary" :loading="loading" @click="search">查询</el-button>
              <el-button size="medium" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>

      </el-form>

      <div class="div_buttom">
        <el-button size="medium" @click="flushedList">刷新列表</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="ID" width="50">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="小程序名称">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="uuid" label="AppID">
          <template slot-scope="scope">{{ scope.row.uuid }}</template>
        </el-table-column>
        <el-table-column prop="platform_type_text" label="平台类型">
          <template slot-scope="scope">{{ scope.row.platform_type_text }}</template>
        </el-table-column>
        <el-table-column prop="owner" label="主体">
          <template slot-scope="scope">{{ scope.row.owner }}</template>
        </el-table-column>

        <el-table-column prop="auto_subscribe" label="自动订阅">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.extends.auto_subscribe"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoSubscribe(scope.row.id,'auto_subscribe',scope.row.extends.auto_subscribe)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column prop="forced_refresh" label="强制更新">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.extends.forced_refresh"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoSubscribe(scope.row.id,'forced_refresh',scope.row.extends.forced_refresh)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column prop="recharge_ios" label="微小IOS充值">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.extends.recharge_ios"
                v-if="scope.row.platform_type==2"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoSubscribe(scope.row.id,'recharge_ios',scope.row.extends.recharge_ios)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column prop="preplay_switch" label="微小视频预加载">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.extends.preplay_switch"
                v-if="scope.row.platform_type==2"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoSubscribe(scope.row.id,'preplay_switch',scope.row.extends.preplay_switch)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="is_allscreen" label="抖小全屏">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.extends.is_allscreen"
                v-if="scope.row.platform_type==1"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoSubscribe(scope.row.id,'is_allscreen',scope.row.extends.is_allscreen)"
            >
            </el-switch>
          </template>
        </el-table-column> -->

        <!-- <el-table-column prop="diamond_pay" label="抖小钻石支付">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.extends.diamond_pay"
                v-if="scope.row.platform_type==1"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoSubscribe(scope.row.id,'diamond_pay',scope.row.extends.diamond_pay)"
            >
            </el-switch>
          </template>
        </el-table-column> -->

        <!-- <el-table-column prop="iaa_switch" label="IAA开关">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.extends.iaa_switch"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoSubscribe(scope.row.id,'iaa_switch',scope.row.extends.iaa_switch)"
            >
            </el-switch>
          </template>
        </el-table-column> -->

        <!-- <el-table-column prop="iaa_recharge" label="IAA免广告充值开关">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.extends.iaa_recharge"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoSubscribe(scope.row.id,'iaa_recharge',scope.row.extends.iaa_recharge)"
            >
            </el-switch>
          </template>
        </el-table-column> -->

      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>

    </el-card>

  </div>
</template>

<script>
import {appListAPI} from '@/api/appletlist/applist/index';
import {processErrors} from "@/utils/errorHandler";

export default {
  components: {},
  data() {
    return {
      SearchFlag: false,
      // 总条数
      total: 0,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      open: false,
      title: "",
      form: {
        id: '',
        pid: '',
        rules: '',
        name: '',
        status: 1// 默认值1
      },
      options: [
        {
          value: 0,
          label: '无父级'
        }
      ],
      tableData: [],
      multipleSelection: [],
      data: [],
      rulesIdList: [],
      rulesIds: "",
      props: {
        label: 'title',
        children: 'children',
        id: 'id',
        pid: 'pid'
      },
      // 展开全部
      expandAll: true,
      // 选择权限
      allSwitchValue: false,
      unfoldSwitchValue: true,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      gutter: 20,
      auto_subscribe: false,
      forced_refresh: false,
      recharge_ios: false,
      preplay_switch: false,
      is_allscreen: false,
      loading: false,
    };
  },
  created() {
    this.getList()
  },
  methods: {

    // 搜索开关
    addSearch() {
      this.SearchFlag = !this.SearchFlag
    },

    search() {
      this.queryParams.pageNo = 1;
      this.getList();
    },

    // 获取列表
    getList() {
      this.loading = true;
      this.tableData = [];
      let api = appListAPI()

      this.queryParams.status = 1;

      api.getAppList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res)
        }
        this.loading = false;
      })
    },

    changeAutoSubscribe(id, name, value) {
      if (id, name, value != undefined) {
        if (value == '1') {
          this.$confirm('确认开启？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(_ => {
            this.updateAutoSubscribe(id, name, value).then(result => {
              if (result.code == 0) {
                this.$message({
                  message: '已开启',
                  type: 'success'
                });
              } else {
                this.tableData.forEach(item => {
                  if (item.id == id) {
                    item.extends[name] = 0;
                  }
                });
                this.$message({
                  message: '开启失败:' + result.msg,
                  type: 'error'
                });
              }
            });
          })
              .catch(_ => {

                this.tableData.forEach(item => {
                  if (item.id == id) {
                    item.extends[name] = 0;
                  }
                });

                this.$message({
                  message: '已取消',
                  type: 'info' // 使用 'info' 类型表示提示信息
                });
                return false;
              });
        } else {
          this.$confirm('确认关闭？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(_ => {

            this.updateAutoSubscribe(id, name, value).then(result => {
              if (result.code == 0) {
                this.$message({
                  message: '已关闭',
                  type: 'success'
                });
              } else {
                this.tableData.forEach(item => {
                  if (item.id == id) {
                    item.extends[name] = 1;
                  }
                });
                this.$message({
                  message: '关闭失败:' + result.msg,
                  type: 'error'
                });
              }
            });
          })
              .catch(_ => {

                this.tableData.forEach(item => {
                  if (item.id === id) {
                    item.extends[name] = 1;
                  }
                });

                this.$message({
                  message: '已取消',
                  type: 'info' // 使用 'info' 类型表示提示信息
                });
              });
        }
      }
    },

    updateAutoSubscribe(id, name, value) {
      let params = {
        id: id,
        name: name,
        value: value
      };
      return appListAPI().editQuickSwitch(params).then(res => {
        return res;
      });
    },

    // 刷新列表
    flushedList() {
      this.getList()
    },

    // 重置
    reset() {
      this.queryParams = {
        name: "",
        platform_type: ''
      }
      this.getList();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },

  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  margin-left: 10px;
}

</style>
